import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxChartsModule, LegendPosition } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-charts',
  standalone: true,
  imports: [CommonModule, NgxChartsModule, BrowserModule, BrowserAnimationsModule],
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.css']
})
export class ChartsComponent implements OnInit{
  multi: any;
  view: any = [800, 400];

  // options
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = true;
  showLegend: boolean = true;
  legendPosition = LegendPosition.Right;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Total Claims Amount per Region vs Total Claims Count per Region';
  showYAxisLabel: boolean = true;
  legendTitle: string = '';
  colorScheme: any = {
    domain: ['#f8051f', '#34495e']
  };

  constructor() {
  }
  ngOnInit(): void {
    this.multi = [
      {
        "name": "Institutional",
        "series": [
          {
            "name": "Claims Amount",
            "value": 730000
          },
          {
            "name": "Claims Count",
            "value": 1200
          }
        ]
      },

      {
        "name": "Energy & Special risks",
        "series": [
          {
            "name": "Claims Amount",
            "value": 890000
          },
          {
            "name": "Claims Count",
            "value": 1500
          }
        ]
      },

      {
        "name": "Corporate 1",
        "series": [
          {
            "name": "Claims Amount",
            "value": 640000
          },
          {
            "name": "Claims Count",
            "value": 8500
          }
        ]
      },
      {
        "name": "Corporate 2",
        "series": [
          {
            "name": "Claims Amount",
            "value": 720000
          },
          {
            "name": "Claims Count",
            "value": 3000
          }
        ]
      },
      {
        "name": "Corporate 3",
        "series": [
          {
            "name": "Claims Amount",
            "value": 890000
          },
          {
            "name": "Claims Count",
            "value": 2500
          }
        ]
      },
      {
        "name": "Lagos Region",
        "series": [
          {
            "name": "Claims Amount",
            "value": 1100000
          },
          {
            "name": "Claims Count",
            "value": 61000
          }
        ]
      },
      {
        "name": "Abuja & North Central Region",
        "series": [
          {
            "name": "Claims Amount",
            "value": 1100000
          },
          {
            "name": "Claims Count",
            "value": 49000
          }
        ]
      },
      // {
      //   "name": "North Region",
      //   "series": [
      //     {
      //       "name": "Claims Amount",
      //       "value": 700000
      //     },
      //     {
      //       "name": "Claims Count",
      //       "value": 49
      //     }
      //   ]
      // },
      // {
      //   "name": "East Region",
      //   "series": [
      //     {
      //       "name": "Claims Amount",
      //       "value": 830000
      //     },
      //     {
      //       "name": "Claims Count",
      //       "value": 49
      //     }
      //   ]
      // },
      // {
      //   "name": "South Region",
      //   "series": [
      //     {
      //       "name": "Claims Amount",
      //       "value": 560000
      //     },
      //     {
      //       "name": "Claims Count",
      //       "value": 23
      //     }
      //   ]
      // },
      // {
      //   "name": "Midwest Region",
      //   "series": [
      //     {
      //       "name": "Claims Amount",
      //       "value": 900000
      //     },
      //     {
      //       "name": "Claims Count",
      //       "value": 15
      //     }
      //   ]
      // },
      // {
      //   "name": "West Region",
      //   "series": [
      //     {
      //       "name": "Claims Amount",
      //       "value": 600000
      //     },
      //     {
      //       "name": "Claims Count",
      //       "value": 29
      //     }
      //   ]
      // },
    ];
  }
}
